import { render, staticRenderFns } from "./kw_menu.vue?vue&type=template&id=174543e9&scoped=true&"
import script from "./kw_menu.vue?vue&type=script&lang=js&"
export * from "./kw_menu.vue?vue&type=script&lang=js&"
import style0 from "./kw_menu.vue?vue&type=style&index=0&id=174543e9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174543e9",
  null
  
)

component.options.__file = "kw_menu.vue"
export default component.exports